<template>
    <v-container>
        <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
                <v-card>
                    <v-container>
                        <form>
                            <v-layout>
                                <v-text-field
                                    name="token"
                                    label="Token Number"
                                    id="token"
                                    v-model="token">
                                </v-text-field>
                            </v-layout>
                            <v-layout>
                                <v-flex xs12>
                                    <v-btn @click.prevent="onTokenChange" type="submit">Submit</v-btn>
                                </v-flex>
                            </v-layout>
                        </form>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import {eventBus} from '../Eventbus/eventbus.js'
export default {
  data () {
    return {
      token: ''
    }
  },
  methods: {
    onTokenChange: function () {
      console.log(this.token)
      eventBus.$emit('tokenChanged', this.token)
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Darshan.vue?9cea1de8